import React from "react";

export default function LogsModal({ serverId, onClose, updateLogs, priceLogs }) {
  const filteredUpdates = updateLogs.filter(
    (l) => l.serverId === serverId || (l.serverId && l.serverId.includes(serverId))
  );
  const filteredPrices = priceLogs.filter(
    (l) => l.serverId === serverId || (l.serverId && l.serverId.includes(serverId))
  );

  return (
    <div className="portal-modal-overlay" onClick={onClose}>
      <div className="portal-modal" onClick={(e) => e.stopPropagation()}>
        <div className="portal-modal-header">
          <h3>Server History Insights: {serverId}</h3>
          <button className="portal-modal-close" onClick={onClose} aria-label="Close modal">
            &times;
          </button>
        </div>
        <div className="portal-modal-body">
          <h4 className="modal-section-title">Software Update History</h4>
          <div className="logs-table-container" style={{ marginBottom: "24px" }}>
            {filteredUpdates.length === 0 ? (
              <div style={{ padding: "16px", color: "var(--text-muted)", fontSize: "var(--fs-xs)" }}>
                No software update logs recorded for this server.
              </div>
            ) : (
              <table className="logs-table">
                <thead>
                  <tr>
                    <th>Date/Time</th>
                    <th>Software</th>
                    <th>Version</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredUpdates.map((log) => (
                    <tr key={log.id}>
                      <td style={{ whiteSpace: "nowrap" }}>
                        {new Date(log.timestamp).toLocaleString()}
                      </td>
                      <td>{log.software}</td>
                      <td>{log.version}</td>
                      <td>
                        <span
                          className="portal-badge"
                          style={{
                            backgroundColor: log.status.toLowerCase().includes("success") || log.status.toLowerCase().includes("done")
                              ? "#193c31"
                              : "#382914",
                            color: log.status.toLowerCase().includes("success") || log.status.toLowerCase().includes("done")
                              ? "#52c48d"
                              : "#EF9F27",
                          }}
                        >
                          {log.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          <h4 className="modal-section-title">Price Update Triggers</h4>
          <div className="logs-table-container">
            {filteredPrices.length === 0 ? (
              <div style={{ padding: "16px", color: "var(--text-muted)", fontSize: "var(--fs-xs)" }}>
                No price update triggers recorded for this server.
              </div>
            ) : (
              <table className="logs-table">
                <thead>
                  <tr>
                    <th>Date/Time</th>
                    <th>Trigger Type</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredPrices.map((log) => (
                    <tr key={log.id}>
                      <td style={{ whiteSpace: "nowrap" }}>
                        {new Date(log.timestamp).toLocaleString()}
                      </td>
                      <td>{log.triggerType}</td>
                      <td>
                        <span
                          className="portal-badge"
                          style={{
                            backgroundColor: "#193c31",
                            color: "#52c48d",
                          }}
                        >
                          {log.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
